import MAIN from "@/locales/MAIN.en.json";

import PHP_CONFIG from "@/locales/PHP_CONFIG.en.json";

export default {
  ...MAIN,
  ...PHP_CONFIG
};
